<script>
import { h } from "vue";
import { icons } from "./iconPaths";

export default {
  name: "AppIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: null },
    stroke: { type: [String, Number], default: 1.8 },
  },
  render() {
    const entry = icons[this.name];
    if (!entry) return null;

    const isExtended = !Array.isArray(entry);
    const shapes = isExtended ? entry.d : entry;
    const isFill = isExtended && entry.fill;
    const viewBox = isExtended && entry.viewBox ? entry.viewBox : "0 0 24 24";

    const sz =
      this.size != null
        ? typeof this.size === "number"
          ? this.size + "px"
          : this.size
        : undefined;

    const children = shapes.map((s) => {
      if (s.text != null) {
        return h(s.tag, s.attrs, [s.text]);
      }
      return h(s.tag, s.attrs);
    });

    const svgAttrs = isFill
      ? {
          viewBox,
          fill: "currentColor",
          ...(sz != null ? { width: sz, height: sz } : {}),
        }
      : {
          viewBox,
          fill: "none",
          stroke: "currentColor",
          "stroke-width": this.stroke,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          ...(sz != null ? { width: sz, height: sz } : {}),
        };

    return h("svg", { ...svgAttrs, class: "app-icon" }, children);
  },
};
</script>
